import { PayloadAction } from "@reduxjs/toolkit";
import { RoleData } from "components/RolesTable/RolesTable";
import { RequestStatus } from "types";
import { FilterRole, FilterRoleState } from "types/FilterRole";

const setFilterRole = (
  state: FilterRoleState,
  action: PayloadAction<FilterRole>
) => {
  state.role = action.payload;
};

const setFilterRoleMembersCount = (
  state: FilterRoleState,
  action: PayloadAction<FilterRole["membersCount"]>
) => {
  state.roleMembersCount = action.payload;
};

const setFilterRoleOptions = (
  state: FilterRoleState,
  action: PayloadAction<RoleData[]>
) => {
  state.roleOptions = action.payload;
};

const setFilterRoleCreationStatus = (
  state: FilterRoleState,
  action: PayloadAction<RequestStatus>
) => {
  state.roleCreationStatus = action.payload;
};

const setFilterRoleRequestStatus = (
  state: FilterRoleState,
  action: PayloadAction<RequestStatus>
) => {
  state.roleRequestStatus = action.payload;
};

const setFilterRoleOptionsRequestStatus = (
  state: FilterRoleState,
  action: PayloadAction<RequestStatus>
) => {
  state.roleOptionsRequestStatus = action.payload;
};

const setFilterRoleUpdateStatus = (
  state: FilterRoleState,
  action: PayloadAction<RequestStatus>
) => {
  state.roleUpdateStatus = action.payload;
};

const setFilterRoleDeletionStatus = (
  state: FilterRoleState,
  action: PayloadAction<RequestStatus>
) => {
  state.roleDeletionStatus = action.payload;
};

const setMembersUpdateStatus = (
  state: FilterRoleState,
  action: PayloadAction<RequestStatus>
) => {
  state.membersUpdateStatus = action.payload;
};

const setSwitchMemberStatus = (
  state: FilterRoleState,
  action: PayloadAction<RequestStatus>
) => {
  state.switchMemberStatus = action.payload;
};

const reducers = {
  setFilterRole,
  setFilterRoleMembersCount,
  setFilterRoleOptions,
  setFilterRoleCreationStatus,
  setFilterRoleRequestStatus,
  setFilterRoleOptionsRequestStatus,
  setFilterRoleUpdateStatus,
  setFilterRoleDeletionStatus,
  setMembersUpdateStatus,
  setSwitchMemberStatus,
};

export default reducers;
